(function(angular) {
    'use strict';
    
    angular.module('reports')
        .controller('ReportsCtrl',  ['$scope', 'apiSpacePicker', '$stateParams', function ($scope, apiSpacePicker, $stateParams) {
                $scope.$on('apiSpacesUpdate:picked', function(){
                        $scope.apiSpace = apiSpacePicker.getPickedApiSpace();
                });
                $scope.pickedApiSpaceId = $stateParams.pickedApiSpaceId;
        }]);
})(window.angular);
